// extracted by mini-css-extract-plugin
export default {"circle":"CircularPortrait_circle__UQMn3"};